// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-post__wrapper .create-post__content{border-radius:12px}@media (min-width:1024px){.create-post__wrapper .create-post__content{max-width:558px}}.create-post__wrapper .create-post__content.has-background{background-color:var(--color-neutral-3)}.create-post__wrapper .create-post__content.create-post__content--full-width{max-width:none}.create-post__wrapper .create-post__content.has-focus-border{border:1px solid var(--color-neutral-4)}.create-post__wrapper .create-post__content.has-focus-border:focus-within{border:1px solid var(--color-primary)}.create-post__wrapper:focus-within .edit-icon svg>*{stroke:var(--color-primary)}.create-post__wrapper .emoji-picker{z-index:1000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
